"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsResultImpl = void 0;
/**
 * @inheritdoc
 */
var MetricsResultImpl = /** @class */ (function () {
    function MetricsResultImpl(sampleCollections) {
        this.sampleCollections = sampleCollections;
    }
    /**
     * @inheritdoc
     */
    MetricsResultImpl.prototype.getServerNames = function () {
        return new Set(Object.keys(this.sampleCollections));
    };
    /**
     * @inheritdoc
     */
    MetricsResultImpl.prototype.getMetrics = function (serverName) {
        return this.sampleCollections[serverName];
    };
    return MetricsResultImpl;
}());
exports.MetricsResultImpl = MetricsResultImpl;
